<script lang="ts" module>
  export const gameOverModal = new ModalState('game-over', { layer: 800 });
</script>

<script lang="ts">
  import ShareButton from '~/share/ShareButton.svelte';
  import type { Match } from '~/types';
  import PostScore from '~/leaderboard/PostScore.svelte';
  import GameSummary from '~/gameOver/GameSummary.svelte';
  import { ModalState } from '~/lib/nav.svelte';
  import ShareModal from '~/share/ShareModal.svelte';
  import SlidePanel from '~/components/SlidePanel.svelte';
  import SplashLogo from '~/components/SplashLogo.svelte';
  import GameScore from './GameScore.svelte';
  import { dims } from '~/utils/dimensions.svelte';
  import ReplayClassic from './ReplayClassic.svelte';
  import HomeButton from '~/components/buttons/HomeButton.svelte';
  import { getGame } from '~/store/GameContext.svelte';
  import { ClassicGame } from '~/store/classic.svelte';

  type Props = {
    words: Match[];
  };
  const props: Props = $props();
  const game = $derived(getGame<ClassicGame>().current);

  const handleToggle = (open: boolean) => {
    if (open) {
      gameOverModal.push();
    } else {
      gameOverModal.pop();
    }
  };
</script>

<ShareModal words={props.words} />
<SlidePanel open={gameOverModal.open} onToggle={handleToggle} zIndex={800}>
  {#snippet title()}
    <SplashLogo animate gameOver />
  {/snippet}
  {#snippet handle()}
    <GameScore open={gameOverModal.open} />
  {/snippet}
  {#snippet content()}
    <div class="content" style="--pad {dims.pad}">
      <GameSummary words={props.words} />
    </div>
  {/snippet}
  {#snippet controls()}
    <PostScore {game} />
    <ShareButton />
    <ReplayClassic />
    <HomeButton />
  {/snippet}
</SlidePanel>

<style lang="scss">
  .content {
    padding: 0 var(--pad);
  }
</style>
